import { render } from "./DashboardSalesChartOld.vue?vue&type=template&id=45b7e1de"
import script from "./DashboardSalesChartOld.vue?vue&type=script&lang=js"
export * from "./DashboardSalesChartOld.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__